import Header from "./dashboard/sub-components/Header";
import '.././styles/upgrade.css'
import { Button } from "@mui/material";
import { db } from './dashboard/firebase/firebase';
import {useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { doc, setDoc, getDocs, collection,getDoc ,query, addDoc, where, updateDoc } from "firebase/firestore";
import BaseNav from "./dashboard/sub-components/BaseNav";
const Verify = () => {
    const user_key = localStorage.getItem('user-key');
    const [code, setCode] = useState(null);
     const [error,setError]=useState('');
     const [clicked,setClicked]=useState(false);
     const allCodes=[];
    const all_user_coupon_code=[];
    const ref = collection(db, "coupon");
    const userRef=collection(db,"user");

     const validate = async ()=>{
         setClicked(true);
          setError('');
         const q=query(ref)
         const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const code={info:doc.data()}
            allCodes.push(code)
        });
        const q2=query(userRef)
        const userSnapShot= await getDocs(q2)
        userSnapShot.forEach((doc)=>{
            const user={user:doc.data()}
            all_user_coupon_code.push(user);
        })
        if(allCodes.map((code)=>(code.info.code)).includes(code)){
            if(all_user_coupon_code.map((user)=>(user.user.coupon)).includes(code)){
                setClicked(false);
                // const user = all_user_coupon_code.filter(user=> user.coupon == code)[0].ema
                setError('This is a used coupon code');
            }else{
                setClicked(false)
                setError('This is an unused coupon code')
            }
        }else{
            setClicked(false)
            setError('This is an invalid coupon code')
        }
     }
    return ( 
        <div className="upgrade-container">
             <div className="gc-box">
                    <span>Verify your coupon code </span>
                    <div className="text-field">
                    <input type="text" placeholder='Enter promotion code' value={code} onChange={(e)=>{setCode(e.target.value)}} />
                    </div>
                    { !clicked &&  <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} onClick={validate}> Proceed</Button>   
                    </div>}
                   
                  {clicked && <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} > Processing</Button>   
                    </div> }
                  <p style={{color:"red",transform:"translateY(2em)",fontSize:"13px"}}>{error}</p>
                </div>
                <div className="buy-coupon">
                <span>I don't have a promotion code?</span>
                <a href="https://viralclicks-mine.net/buy-coupon-code">Click here</a>
                </div>
            {/* </div> */}
            
        </div> 
     );
}
 
export default Verify;
